import { z } from 'zod';
export const zUserMessageSchema = z.object({
    __typename: z.literal('ChatMessage'),
    id: z.string().uuid(),
    content: z.string().nullable(),
    data: z.object({
        promptId: z.string().uuid(),
        type: z.literal('document-workflow'),
    }),
});
